/** The file was automatically generated. Please do not modify manually */
import cs from './online.json';
export var strings_cs = cs;
